import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOfficetoNutshellRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 128 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m19.473 27.756-16-2.5 16 6 9.5-2.5v-25l-9.5-2.5-16 6v17.5l5.5-2v-14.5l10.5-2.5z",
			fill: "#eb3c00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.424 14.656a1.6 1.6 0 0 0 0 3.2zm29.931 2.731a1.6 1.6 0 0 0 0-2.263L71.173 4.942a1.6 1.6 0 0 0-2.263 2.263l9.051 9.05-9.05 9.052a1.6 1.6 0 0 0 2.262 2.262zm-29.931-1.131v1.6h28.8v-3.2h-28.8z",
			fill: "#4d4540"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.326 5.886a1.01 1.01 0 0 1-.951-1.208l.684-3.636a1 1 0 0 0 .019-.17c0-.771-1.081-.872-2.48-.872s-2.484.1-2.484.872q0 .086.019.17l.694 3.636a1.016 1.016 0 0 1-.977 1.198c-6.699.234-11.426 2.428-11.426 6.43v1.539a.736.736 0 0 0 .736.736h12.191a.7.7 0 0 1 .691.448q.054.14.048.287a.686.686 0 0 1-.586.687l-9.04 1.752a.69.69 0 0 0-.586.713v3.096c0 5.944 4.648 10.947 10.72 10.947A10.743 10.743 0 0 0 124.34 21.77v-6.492a.714.714 0 0 1 .736-.71h1.953a.74.74 0 0 0 .749-.735v-1.54c0-4.01-4.727-6.048-11.452-6.406",
			fill: "#fe5800"
		})
	]
});
export default SvgOfficetoNutshellRegularIcon;
